import React from "react";
import { BottomNavigation, BottomNavigationAction, Paper } from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";
import FavoriteIcon from "@mui/icons-material/Favorite";
import PersonIcon from "@mui/icons-material/Person";
import EditCalendarIcon from '@mui/icons-material/EditCalendar';
import { useNavigate, useLocation } from "react-router-dom";
import ShareLocationIcon from '@mui/icons-material/ShareLocation';
const FixedBottomNavigation = () => {
  const navigate = useNavigate();
  const location = useLocation(); // ✅ 현재 URL 경로 감지

  // ✅ 현재 경로에 따라 선택된 탭 설정
  const getValueFromPath = (path) => {
    switch (path) {
      case "/main":
        return 0;
      case "/find":
        return 1;
      case "/search":
        return 2;
      case "/wishlist":
        return 3;
      case "/profile":
        return 4;
      default:
        return 0; // 기본값
    }
  };

  return (
    <Paper sx={{ position: "fixed", bottom: 0, left: 0, right: 0 }} elevation={3}>
      <BottomNavigation
        showLabels
        value={getValueFromPath(location.pathname)} // ✅ 현재 경로 기반으로 value 설정
        onChange={(event, newValue) => {
          switch (newValue) {
            case 0:
              navigate("/main");
              break;
            case 1:
              navigate("/find");
              break;
            case 2:
              navigate("/search");
              break;
            case 3:
              navigate("/wishlist");
              break;
            case 4:
              navigate("/profile");
              break;
            default:
              navigate("/main");
          }
        }}
      >
        <BottomNavigationAction sx={{flex:1,width:'100%'}} label="홈" icon={<HomeIcon />} />
        <BottomNavigationAction sx={{flex:1,width:'100%'}} label="어디가?" icon={<EditCalendarIcon />} />
        <BottomNavigationAction sx={{flex:1,width:'100%'}} label="맵" icon={<ShareLocationIcon />} />
        <BottomNavigationAction sx={{flex:1,width:'100%'}} label="좋아요" icon={<FavoriteIcon />} />
        <BottomNavigationAction sx={{flex:1,width:'100%'}} label="프로필" icon={<PersonIcon />} />
      </BottomNavigation>
    </Paper>
  );
};

export default FixedBottomNavigation;
